module.exports = __webpack_public_path__ + "static/images/smoothness/ui-icons_888888_256x240.png";